import MuiTab from "@material-ui/core/Tab";
import MuiTabs from "@material-ui/core/Tabs";
import { FieldConfig } from "formik";
import { t } from "i18next";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";
type TabOption = { value: any; title: string };

interface Props extends FieldConfig {
  options: TabOption[];
  setState: any;
  selected: string;
}

const useTabsStyles = makeThemedStyles("Toolbars.Tabs", (theme) => ({
  root: {
    backgroundColor: "#fff",
    display: "inline-flex",
    alignItems: "center",
    border: "1.5px solid rgba(0,0,0,0.14)",
    borderRadius: "32px",
    minHeight: "32px",
    color: "rgb(148, 143, 143)",
    textTransform: "unset",
    height: "40px",
    width: "640px",
    background: "gray",
  },
  indicator: {
    borderRadius: "32px",
    height: "100%",
    backgroundColor: "rgb(244,244,244)",
  },
}));

const useTabStyles = makeThemedStyles("Toolbars.Tabs", (theme) => ({
  root: {
    flex: 1,
    minHeight: "30px",
    fontSize: "10px",
    fontWeight: 500,
    textAlign: "center",
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    lineHeight: "28px",
    color: "#7E8791",
    maxWidth: "72vw",
  },
  selected: {
    zIndex: 1,
    color: "#fff",
    borderRadius: "32px",
    backgroundColor: "#00A9A3",
  },
}));

const StateTabs = (props: Props) => {
  const tabClasses = useTabStyles();
  const tabsClasses = useTabsStyles();
  return (
    <MuiTabs
      classes={{
        root: tabsClasses.root,
        indicator: tabsClasses.indicator,
      }}
      onChange={(a, b) => {
        props.setState(b);
      }}
      value={props.selected}
    >
      {props.options.map((tab, index) => (
        <MuiTab
          key={index}
          classes={{ root: tabClasses.root, selected: tabClasses.selected }}
          value={tab.value}
          label={t(tab.title)}
        />
      ))}
    </MuiTabs>
  );
};

export default StateTabs;
